
import Vue from "vue";
import { Prop, Component, Watch } from "vue-property-decorator";

@Component
export default class DateRange extends Vue {
  localValue = null;

  created() {
    this.localValue = this.value;
  }

  @Watch("value")
  valueChanged(val) {
    this.localValue = val;
  }

  @Watch("localValue")
  localValueChanged(val) {
    this.$emit("input", val);
  }

  @Prop({ default: "name" })
  name: string;

  @Prop({ default: "" })
  value: string;

  @Prop({ default: "displayName" })
  placeholder: string;

  get dateRange() {
    if (this.localValue) {
      const dateData = this.localValue.split(" ~ ");
      const startDate = dateData[0].indexOf("null") < 0 ? dateData[0] : null;
      const endDate = dateData[1].indexOf("null") < 0 ? dateData[1] : null;
      return {
        start: startDate,
        end: endDate
      };
    } else {
      return "";
    }
  }

  set dateRange(value: any) {
    this.localValue = value ? `${value.start} ~ ${value.end}` : "";
  }

  updateDate(value: any) {
    this.localValue = `${value.start} ~ ${value.end}`;
  }

  validateDate() {
    const dateData = this.localValue.split(" ~ ");
    const startDate = dateData[0].indexOf("null") < 0 ? dateData[0] : null;
    const endDate = dateData[1].indexOf("null") < 0 ? dateData[1] : startDate;
    this.localValue = `${startDate} ~ ${endDate}`;
  }

  reset() {
    this.localValue = "";
  }
}
